$(document).ready(function () {

});

$(document).on("click", "button.minus", function () {
	console.log('minus');
	let num = parseInt($(this).next().val());
	let min = $(this).next().attr('min');
	let max = $(this).next().attr('max');
	if (num - 1 <= min) {
		$(this).next().val(min);
	} else {
		$(this).next().val(num - 1);

	}
});
$(document).on("click", "button.plus", function () {
	console.log('plus');
	let num = parseInt($(this).prev().val());
	let min = $(this).prev().attr('min');
	let max = $(this).prev().attr('max');
	if (num + 1 >= max) {
		$(this).prev().val(max);
	} else {
		$(this).prev().val(num + 1);

	}


});
